import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Portal from "@/pages/Portal";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import BlindDate from "@/pages/BlindDate";
import Admin from "@/pages/Admin";
import AdsterraGlobal from "@/components/AdsterraGlobal";
import AgeGate from "@/components/AgeGate";
import { Privacy, Terms } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AgeGate>
          <AuthProvider>
            <AdsterraGlobal />
            <Routes>
              <Route path="/" element={<Navigate to="/portal" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
              <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/blinddate" element={<ProtectedRoute><BlindDate /></ProtectedRoute>} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Toaster position="top-center" theme="dark" richColors />
          </AuthProvider>
        </AgeGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
